/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// require('./components/Example');

import { InertiaApp } from '@inertiajs/inertia-react'
import { ScreenContextProvider } from 'components/ScreenContext';
import React from 'react'
import { render } from 'react-dom'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import smoothscroll from 'smoothscroll-polyfill';
import { ModalsProvider } from './components/Layouts/Modals';
import { InertiaProgress } from '@inertiajs/progress'
import { gtag } from 'assets/js/gtm'

// kick off the polyfill!
smoothscroll.polyfill();

// import createInertiaApp from '@inertiajs/inertia-react/src/createInertiaApp'
import { createInertiaApp } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia';
import moment from 'moment';

Inertia.on('before', (event) => {
  if (event.detail.visit.url.pathname != window?.location.pathname) {
    document?.documentElement.classList.remove('scroll-smooth');
    document?.body.classList.remove('scroll-smooth');
  }
})

Inertia.on('finish', (event) => {
  document?.body.classList.add('scroll-smooth');
  document?.documentElement.classList.add('scroll-smooth');
})

Inertia.on('navigate', (event) => {
  gtag('event', 'page_view', {
   'page_location': event.detail.page.url
  });
})

InertiaProgress.init({

  // Whether to include the default NProgress styles.
  includeCSS: false,

  // Whether the NProgress spinner will be shown.
  showSpinner: window?.location.pathname?.includes('/admin/'),
})

moment.locale('cs');

createInertiaApp({
  resolve: name => {
    let page = require(`./pages/${name}`);
    // page.default.layout = ((page) => CartContextProvider(page));
    return page;
  },
  setup({ el, App, props }) {
    render(
      <ScreenContextProvider>
        <ModalsProvider>
          <App {...props} />
        </ModalsProvider>
      </ScreenContextProvider>
      , el
    )
  },
})

gtag('js', new Date());
gtag('config', 'UA-188280036-1');

try {
  Sentry.init({
    dsn: "https://0b1b56e710df4caaabfcd5a76b7ad361@o1080203.ingest.sentry.io/6085724",
    integrations: [new Integrations.BrowserTracing()],
  
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
} catch (error) { }




// const app = document?.getElementById('app')

// render(

//   <ScreenContextProvider>
//     <ModalsProvider>
//       <InertiaApp
//         initialPage={JSON.parse(app?.dataset.page as string)}
//         resolveComponent={name => import(`./pages/${name}`).then(module => module.default)}
//       />
//     </ModalsProvider>
//   </ScreenContextProvider>
//   , app
// )

